
import Entity from './Entity.js'

class EntityCollection {

    constructor(data = {}) {
        this.data = data;
    }

    hasId(id) {
        return (this.data[id] === undefined) ? false : true;
    }

    has(entity) {
        if(!(entity instanceof Entity)) {
            throw new Error('EntityCollection can only contain Entity instances');
        }
        return this.hasId(entity.getId());
    }
    
    getById(id) {
        if(!this.hasId(id)) {
            throw new Error('No entity for id "' + id + '" exists in this collection');
        }
        
        return this.data[id];
    }

    add(entity) {
        if(!(entity instanceof Entity)) {
            throw new Error('EntityCollection can only contain Entity instances');
        }
        if (this.has(entity)) {
            throw new Error('Collection already has entity with an id of "' + entity.getId() + '"');
        }
        entity.addCollectionReference(this);
        this.data[entity.getId()] = entity;
        return this;
    }
    
    remove(entity) {
        if(!(entity instanceof Entity)) {
            throw new Error('EntityCollection can only contain Entity instances');
        }
        if(!this.has(entity)) {
            throw new Error('Collection does not have an entity with id of "' + entity.getId() + '"')
        }
        this.data[entity.getId()] = undefined;
        delete this.data[entity.getId()];
        return this;
    }

    forEach(cb) {
        for(const i in this.data) {
            const entity = this.data[i];
            if(entity === undefined) {
                continue;
            }
            cb(entity, i);
        }
        return this;
    }
    
    tickAll() {
        return this.forEach((entity, i) => {
            entity.tick();
        });
    }
    
    drawAll(ctx) {
        return this.forEach((entity, i) => {
            entity.draw(ctx);
        });
    }
}

export default EntityCollection
